'use client'

import {useState } from 'react'

import ProductSearchPage from '@/entities/productSearch'
import { Helmet } from 'react-helmet'
import { Container } from 'react-bootstrap'
import LoaderPage from '@/shared/ui/LoaderPage'

export const SearchPage = () => {
    const [mount, setMount] = useState(false)
    
    return (
        <Container className={'SearchPage'}>
            <Helmet>
                <title>Страница поиска</title>
            </Helmet>
            <ProductSearchPage setMount={setMount} />
            <LoaderPage loading={!mount} />
        </Container>
    )
}
